<template>
  <QCheckbox
    v-model="checked"
    :class="['checkbox-button', ...[fullWidth && 'full-width'], ...[removeOpacity && 'remove-opacity']].join(' ')"
    color="secondary"
    @input="handleInput"
    :disable="disabled"
  >
    <CalculatorButton
      class="checkbox-button-label"
      :color="checked ? color : undefined"
      :rounded="rounded"
      :hasChevronIcon="includeChevronIcon ? checked : undefined"
      :label="computedLabel"
      outlined
      :disabled="disabled"
      :removeOpacity="removeOpacity"
      :stack="stack"
      :greyBorder="greyBorder"
      :tertiaryBorder="tertiaryBorder"
    >
      <slot></slot>
    </CalculatorButton>
  </QCheckbox>
</template>

<script>
import { QCheckbox } from 'quasar';
import CalculatorButton from './CalculatorButton';

export default {
  name: 'CheckboxButton',
  props: {
    color: {
      type: String,
      default: 'secondary'
    },
    rounded: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    includeChevronIcon: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    stack: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    greyBorder: {
      type: Boolean,
      default: false
    },
    tertiaryBorder: {
      type: Boolean,
      default: false
    },
    removeOpacity: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: this.value
    };
  },
  watch: {
    value(newValue) {
      this.checked = newValue;
    }
  },
  methods: {
    handleInput() {
      this.$emit('input', this.checked);
    }
  },
  computed: {
    computedLabel() {
      // Use the label prop value as the computed label
      return this.label;
    }
  },
  components: {
    QCheckbox,
    CalculatorButton
  }
};
</script>

<style lang="sass">
.checkbox-button.q-checkbox
  .q-checkbox__inner
    display: none
    .no-outline
      display: none
  &.remove-opacity, .remove-opacity:disabled
    opacity: 1!important
  // Inner QBtn otherwise captures taps; Quasar toggles from the label, not the nested button (mobile drawer / repayments).
  .checkbox-button-label.q-btn
    pointer-events: none
  &.full-width .q-checkbox__label
    width: 100%
    .q-btn
      width: 100%
</style>
